'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Back';
import TextInput from 'Components/Forms/Elements/TextInput';
import Select from 'Components/Forms/Elements/Select';
import handleChange from 'Components/Forms/Functions/handleChange';
import Dashboard from 'Components/Lists/Dashboard';
import ArrivalRow from 'Components/Lists/Rows/Arrival';
import { action } from 'Shared/Routes';
const {
  app,
  moment
} = window;
const header = [{
  name: 'arrival_start_hour',
  label: 'Heure d\'arrivé',
  sortable: false
}, {
  name: 'arrival_customer.lastname',
  label: 'Client',
  sortable: false
}, {
  name: 'arrival_coworking_space.type',
  label: 'Type de prestation',
  sortable: false
}, {
  name: 'arrival_duration',
  label: 'Durée',
  sortable: false
}, {
  name: 'arrival_PDF',
  label: 'PDF',
  sortable: false
}, {
  name: 'arrival_status',
  label: 'Statut',
  sortable: false
}, {
  name: 'arrival_actions',
  sortable: false
}];
const arrival_status_options = [{
  value: "attendus",
  label: "Attendus"
}, {
  value: "arrivees",
  label: "Arrivées"
}, {
  value: "departs",
  label: "Départs"
}, {
  value: "no_show",
  label: "No show"
}, {
  value: "all",
  label: "Toutes les arrivées"
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = ['arrival_status'];
export default class ArrivalsDashboardPage extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Prevent on mount trigger
    if (!e && fields_without_timeout.includes(name) === false) return;
    component.setState({
      [name]: value
    });
    if (fields_without_timeout.includes(name)) return;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
    }
    component.search_timeout = window.setTimeout(function () {
      component.search_timeout = undefined;
      component.setState({
        ['delayed_' + name]: value
      });
    }, 320);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const etablishment_id = app.state?.session?.user?.etablishment;
    let filters = {
      searched: state.delayed_searched,
      searched_lastname: state.delayed_searched_lastname,
      etablishment_id: etablishment_id,
      arrival_status: state.arrival_status,
      date: moment().format('YYYY-MM-DD'),
      status: {
        $in: ['paid', 'confirmed']
      },
      fetch_name: 'arrivals'
    };
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Arriv\xE9es du jour"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleSearchChange,
      placeholder: "Recherche (mail)",
      value: state['searched'],
      name: "searched",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleSearchChange,
      placeholder: "Recherche (nom)",
      value: state['searched_lastname'],
      name: "searched_lastname",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      onChange: component.handleChange,
      value: state['arrival_status'],
      name: "arrival_status",
      label: "Statut",
      status: state.status_messages,
      options: arrival_status_options,
      "default-value": arrival_status_options[0].value
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, etablishment_id ? /*#__PURE__*/React.createElement(Dashboard, {
      model: "Booking",
      url: action('getAllBookings'),
      header: header,
      fields: fields,
      component: ArrivalRow,
      "items-per-page": 30,
      filters: filters
    }) : undefined))));
    return output;
  }
}
